export async function uploadEligibilityFile(file, token) {
  const formData = new FormData();
  formData.append("file", file);
  const response = await fetch(`${process.env.HAHS_API_URL}/eligibilities`, {
    method: "POST",
    body: formData,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  if (!response.ok) {
    throw new Error(await response.text());
  }
  return response.json();
}

export async function fetchEligibilityHistory(
  token: string,
  params: {
    org?: string;
    status?: string;
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDir?: "asc" | "desc";
  } = {}
) {
  const query = new URLSearchParams();
  if (params.org) query.append("org", params.org);
  if (params.status) query.append("status", params.status);
  if (params.page) query.append("page", params.page.toString());
  if (params.pageSize) query.append("pageSize", params.pageSize.toString());
  if (params.sortBy) query.append("sortBy", params.sortBy);
  if (params.sortDir) query.append("sortDir", params.sortDir);
  const url = `${process.env.HAHS_API_URL}/eligibilities?${query.toString()}`;
  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  if (!response.ok) {
    throw new Error(await response.text());
  }
  return response.json();
}

export async function fetchEligibilityDetail(token: string, id: string) {
  const url = `${process.env.HAHS_API_URL}/eligibilities/${id}`;
  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  if (!response.ok) {
    throw new Error(await response.text());
  }
  return response.json();
}

export async function downloadEligibilityFile(token: string, id: string) {
  const url = `${process.env.HAHS_API_URL}/eligibilities/${id}/download`;
  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  if (!response.ok) {
    throw new Error(await response.text());
  }
  return response.json();
}
